







































































import {Component, Prop} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import Template from '@/views/reports/forms/traffic_sources/template.vue';
import PeriodPicker from '@/views/reports/pickers/period-picker.vue';
import ReportMetricsMixin from '@/views/reports/mixins/report-metrics-mixin';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import ReportFiltersCommon from '@/views/reports/report-filters-common';
import UrlMixin from '@/components/query/url-mixin';
import MetricsMixin from '@/views/reports/pickers/base/metrics-mixin';
import ColumnsSettingsDialogMixin from '@/views/reports/pickers/cores/columns-settings-dialog/columns-settings-dialog-mixin';
import api from '@/services/utils/base';
import qs from 'qs';
const md5 = require('md5');

@Component({
  components: {
    Template,
    FormOverlay,
    DialogForm,
    HeaderButtons,
    PeriodPicker,
    ErrorAggregator,
  }
})

export default class ShareReportDialog extends mixins(
    ReportMetricsMixin,
    ReportFiltersCommon,
    mixins(ColumnsSettingsDialogMixin, UrlMixin, MetricsMixin)
  ){

  active: boolean = false;
  searchColumn: string = '';
  columns = {};
  selectAll: boolean = false;
  disabledColumns={}
  oldHash: string = '';

  mounted() {
    const selectedColumns = this.$store.state.table.exportParams.columns

    this.setSelectedColumns(selectedColumns)

    this.selectAll = this.selectedColumns.length === Object.keys(this.columns).length
    this.searchColumn = '';
    this.active = true;

    this.$nextTick(() => {
      this.oldHash = this.getCurrentHash();
    });
  }

  getCurrentHash() {
    return md5(JSON.stringify({ ...this.columns }));
  }

  checkClose() {
    if (this.oldHash !== this.getCurrentHash()) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
    } else {
      this.close();
    }
  }

  get columnsList() {
    return this.existing_metrics.map((item)=>{
      if(item.disabled){
        this.disabledColumns[item.value]=true;
      }
      return {
        ...item,
        planLimits:this.getPlanLimits(item) 
      }
    })
  }

  get selectedColumns() {
    return Object.entries(this.columns).reduce((acc, [key, value]) => {
      if (value) {
        acc.push(key)
      }
      return acc
    }, [])
  }

  toggleSelectAll(val) {
    this.columnsList.forEach(({ value }) => {
      if(this.disabledColumns[value]) return;
      this.columns[value] = val;
    })
  }

  handleToggle(key, value) {
    this.columns[key] = value
    this.selectAll = this.selectedColumns.length === Object.keys(this.columns).length
  }

  get filteredColumns() {
    return this.columnsList.filter(({ text }) => text.toLowerCase().includes(this.searchColumn.toLowerCase()))
  }

  setSelectedColumns(selectedColumns) {
    this.columns = this.columnsList.reduce((acc, { value }) => {
      acc[value] = selectedColumns.includes(value)
        || this.additionalMainColumns.findIndex((item)=>item.value === value) !== -1;
      return acc
    }, {})
  }

  close() {
    this.$emit('close');
  }

  get isTreeView() {
    return this.$store.getters.tableQueryForCurrentTab.view === 'tree' && this.$store.getters.tableQueryForCurrentTab.treeLevels?.some((e: string) => e);
  }

  get groupBy() {
    const { reportParams } = this.$store.getters;
    return [reportParams.groupBy, ...(this.$store.getters.tableQueryForCurrentTab?.treeLevels?.filter(item=>!!item) || [])]
  }

  submit() {
    const exportParams = this.$store.state.table.exportParams;

    (window as any).location = api.getUri({
      method: 'GET',
      url: api.config.baseURL + this.requestLink,
      params: {
        ...exportParams,
        groupBy:this.groupBy,
        export:'csv',
        orderBy: this.selectedColumns.includes(exportParams.orderBy) ? exportParams.orderBy : this.selectedColumns[0],
        accesstoken:this.$store.state.authToken,
        columns:this.selectedColumns,
        formatResponse:0,
        presetId:this.$store.state.report.activePreset
      },
      paramsSerializer: function(params: object) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    });
    this.close()
  }

}
